export default "__VITE_ASSET__pAsfeAf___"